"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIAbstractPageGridContent;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _UIMain = _interopRequireDefault(require("../layout/UIMain"));

var CustomRenderer = _interopRequireWildcard(require("../utils/propTypes/customRenderer"));

var _sizes = require("HubStyleTokens/sizes");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 100vh;\n  margin-left: -", ";\n  overflow-y: auto;\n  padding-left: ", ";\n  position: sticky;\n  top: 0;\n\n  @media only screen and (max-width: ", ") {\n    height: auto;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex: 1 0 0%;\n  max-width: ", ";\n  padding-left: 16px;\n  padding-right: 16px;\n  position: relative;\n\n  @media only screen and (max-width: 679px) {\n    max-width: ", ";\n  }\n\n  @media only screen and (max-width: ", ") {\n    flex-basis: 100%;\n    max-width: 100%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex: 0 0 33%;\n  max-width: 224px;\n  padding-left: 16px;\n  padding-right: 16px;\n  position: relative;\n\n  @media only screen and (max-width: ", ") {\n    flex-basis: 100%;\n    max-width: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-wrap: nowrap;\n  margin-left: -16px;\n  margin-right: -16px;\n\n  @media only screen and (max-width: ", ") {\n    flex-wrap: wrap;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Outer = _styledComponents.default.div.withConfig({
  displayName: "UIAbstractPageGridContent__Outer",
  componentId: "sc-1abaf6e-0"
})(_templateObject(), _sizes.GRID_BREAKPOINT_SMALL);

var Sidebar = _styledComponents.default.div.withConfig({
  displayName: "UIAbstractPageGridContent__Sidebar",
  componentId: "sc-1abaf6e-1"
})(_templateObject2(), _sizes.GRID_BREAKPOINT_SMALL);

var MainContainer = _styledComponents.default.div.withConfig({
  displayName: "UIAbstractPageGridContent__MainContainer",
  componentId: "sc-1abaf6e-2"
})(_templateObject3(), function (_ref) {
  var hasSidebar = _ref.hasSidebar;
  return hasSidebar ? 'calc(100% - 224px)' : '100%';
}, function (_ref2) {
  var hasSidebar = _ref2.hasSidebar;
  return hasSidebar && '67%';
}, _sizes.GRID_BREAKPOINT_SMALL);

var STICKY_STYLES = (0, _styledComponents.css)(_templateObject4(), _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_LEFT, _sizes.GRID_BREAKPOINT_SMALL);

var SidebarContainer = _styledComponents.default.div.withConfig({
  displayName: "UIAbstractPageGridContent__SidebarContainer",
  componentId: "sc-1abaf6e-3"
})(_templateObject5(), function (props) {
  return props.stickySidebar && STICKY_STYLES;
});

function UIAbstractPageGridContent(props) {
  var children = props.children,
      sidebarComponent = props.sidebarComponent,
      stickySidebar = props.stickySidebar;
  return _react.default.createElement(Outer, null, sidebarComponent && _react.default.createElement(Sidebar, null, _react.default.createElement(SidebarContainer, {
    stickySidebar: stickySidebar
  }, CustomRenderer.render(sidebarComponent))), _react.default.createElement(MainContainer, {
    hasSidebar: !!sidebarComponent
  }, _react.default.createElement(_UIMain.default, {
    flush: true
  }, children)));
}

UIAbstractPageGridContent.propTypes = {
  children: _propTypes.default.node,
  sidebarComponent: CustomRenderer.propType,
  stickySidebar: _propTypes.default.bool
};
UIAbstractPageGridContent.defaultProps = {
  stickySidebar: false
};
UIAbstractPageGridContent.displayName = 'UIAbstractPageGridContent';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/page/UIAbstractPageGridContent.js
// module id = 689
// module chunks = 209 210 211 212